export const JobStatuses = {
  CREATED: 'CREATED',
  FAILED: 'FAILED',
  SUCCESS: 'SUCCESS',
  RUNNING: 'RUNNING',
} as const;
